module.exports = __webpack_public_path__ + "img/deleteIcon.53dcdb91.svg";